import { PersonService } from '../../core/http/service/PersonService';
import { QuestionnaireService } from '../../core/http/service/QuestionnaireService';
import BaseResponse from '../../models/core/BaseResponse';
import Avaliacao from '../../models/core/questionnaire/Avaliacao';
import AvaliacaoResposta from '../../models/core/questionnaire/AvaliacaoResposta';
import Questionnaire from '../../models/core/questionnaire/Questionnaire';
import Resposta from '../../models/core/questionnaire/Resposta';

export const FETCH_QUESTIONARIO_OMS = 'FETCH_QUESTIONARIO_OMS';
export const FETCH_QUESTIONARIO_HMV = 'FETCH_QUESTIONARIO_HMV';
export const FETCH_AVALIACAO = 'FETCH_AVALIACAO';
export const RESET_AVALIACAO = 'RESET_AVALIACAO';
 
const sendToAnalytics = (action: string = '', error: any = null) =>{
    console.error(action, error); 
}
 
export const fetchQuestionarioOMS = ()=>{ 
    const service: QuestionnaireService = new QuestionnaireService();
    return async (dispatch: any)=>{ 
        try{ 
            const response: any = await service.getQuestionario('801bea09-a642-4711-a12a-a6d9e7930e28')
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
            
            const questionarioOMS = new Questionnaire().fromJSON({...baseResponse.data})

            dispatch({ 
                type: FETCH_QUESTIONARIO_OMS, 
                questionario: questionarioOMS
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
};

export const fetchQuestionarioHMV = ()=>{
    const service: QuestionnaireService = new QuestionnaireService();
    return async (dispatch: any)=>{ 
        try{ 
            const response: any = await service.getQuestionario('564d7778-7643-4401-979e-40e49f35c2e3')
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
            
            const questionarioHMV = new Questionnaire().fromJSON({...baseResponse.data})

            dispatch({ 
                type: FETCH_QUESTIONARIO_HMV, 
                questionario: questionarioHMV
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const fetchAvaliacao = (avaliacaoId: string, pessoaId: string)=>{
    const service: PersonService = new PersonService();
    return async (dispatch: any)=>{ 
        try{ 
            const response: any = await service.getAvaliacaoById(avaliacaoId, pessoaId)
            const baseResponse: BaseResponse<any> = new BaseResponse().fromJSON(response.data)
            
            const avaliacao = new AvaliacaoResposta().fromJSON({...baseResponse.data})

            dispatch({ 
                type: FETCH_AVALIACAO, 
                avaliacao: avaliacao
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const resetAvaliacao = ()=>{
    return async (dispatch: any)=>{ 
        try{ 
            dispatch({ 
                type: RESET_AVALIACAO, 
            })
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
} 

export const registerQuestionarioOMS = (questionList: any[], allAnswers: any[], textAnswers: any[], id: string, versao: number, avaliacaoId: string | null, pessoaId: string)=>{
    const service: PersonService = new PersonService();
    return async (dispatch: any)=>{
        try{
            const respostas: any = [];
            questionList.forEach((q: any)=>{
                q.perguntas.forEach((p:any)=>{
                    let resposta: any[] = []
                    let object: Resposta = new Resposta();
                    if(q.labelEscalas.length > 0){
                        resposta = allAnswers.filter((answer: any)=>{
                            return answer.questionId === p.id;
                        })
    
                        object = new Resposta().fromJSON({perguntaId: p.id, 
                            perguntaAnteriorId: null, 
                            valor: resposta[0].codigo,
                            alternativas: [{alternativaId: resposta[0].id, ordem: Number(resposta[0].codigo), texto: ''}]})
                    }else{
    
                        resposta = textAnswers.filter((answer: any)=>{
                            return answer.questionId === p.id
                        })
                        object = new Resposta().fromJSON({
                            perguntaId: p.id, 
                            perguntaAnteriorId: null,
                            valor: resposta[0].text,
                            alternativas: []
                        })
                    }
    
                    respostas.push(object)
                })
            })
            const object = new Avaliacao().fromJSON({ questionarioId: id, versao: versao, finalizada: true, respostas: respostas })
            if(avaliacaoId === null){
                await service.registerQuestionnaire(pessoaId, object)
            }else{
                await service.updateQuestionnaire(pessoaId, avaliacaoId, object)
            }
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}

export const registerQuestionarioHMV = (isSalvar: boolean, enunciadosAbertos: any[], allAnswers: any[], textAnswers: any[], id: string, versao: number, avaliacaoId: string | null, pessoaId: string)=>{
    const service: PersonService = new PersonService();
    return async (dispatch: any)=>{
        try{
            const respostas: any[] = []
            enunciadosAbertos.forEach(enunciado=>{
                let resposta: any[];
                if(enunciado.tipoDadoResposta.codigo !== 'lista' && enunciado.tipoDadoResposta.codigo !== 'intervalo'){
                    resposta = textAnswers.filter((r: any)=>{ return r.questionId === enunciado.pergunta.id })
                    if(resposta.length > 0){
                        const object = new Resposta().fromJSON({
                            perguntaId: resposta[0].questionId, 
                            perguntaAnteriorId: null,
                            valor: resposta[0].text,
                            alternativas: []
                        })
                        respostas.push(object)
                    }
                }else if(enunciado.tipoDadoResposta.codigo === 'intervalo'){
                    resposta = allAnswers.filter((r: any)=>{ return r.questionId === enunciado.pergunta.id })
                    if(resposta.length > 0){
                        const object = new Resposta().fromJSON({
                            perguntaId: resposta[0].questionId, 
                            perguntaAnteriorId: null,
                            valor: resposta[0].value,
                            alternativas: []
                        })
                        respostas.push(object)
                    }
                }else{
                    resposta = allAnswers.filter((r: any)=>{ return r.questionId === enunciado.pergunta.id })
                    const alternativas: any[] = []
                    if(resposta.length > 0){
                        resposta.forEach(alternativa=>{
                            let respostaFinal;
                            if(alternativa.entradaTexto){
                                const respostaFinalList: any[] = textAnswers.filter(((r: any)=>{ return r.questionId === enunciado.pergunta.id && r.id === alternativa.id }))
                                if(respostaFinalList.length > 0){
                                    respostaFinal = respostaFinalList[0]
                                    alternativas.push({alternativaId: respostaFinal.id, ordem: respostaFinal.ordem, texto: respostaFinal.respostaTexto})
                                }
                            }else{
                                alternativas.push({alternativaId: alternativa.id, ordem: alternativa.ordem, texto: ''})
                            }
                        })

                        let obj = new Resposta().fromJSON({
                            perguntaId: enunciado.pergunta.id, 
                            perguntaAnteriorId: null,
                            valor: null,
                            alternativas: alternativas
                        })
            
                        respostas.push(obj)
                    }

                }
            })
            const object = new Avaliacao().fromJSON({ questionarioId: id, versao: versao, finalizada: !isSalvar, respostas: respostas })
            const response: any = await service.getAvaliacaoByPessoaId(id, pessoaId)
            const avaliacao = response.data.data.length === 0? null : response.data.data[0];
            
            if(avaliacao === null || avaliacao.finalizada){
                await service.registerQuestionnaire(pessoaId, object)
            }else{
                await service.updateQuestionnaire(pessoaId, avaliacao.id, object)
            }
        }catch(error: any){
            sendToAnalytics(error);
            throw error; 
        }
    }
}